export const root = '/toolbox';

export const collections = `${root}/collections`;
export const collection = `${collections}/:collectionId`;

export const integrations = `${root}/integrations`;
export const integration = `${integrations}/:integrationId`;

export const offers = `${root}/offers`;
export const offer = `${offers}/:offerId`;

export const getCollectionPath = (id: string) => `${collections}/${id}`;
export const getIntegrationPath = (id: string) => `${integrations}/${id}`;
export const getOfferPath = (id: string) => `${offers}/${id}`;
